<template id="mapTmpl">
		<ct-main-layout-appgui :backurl="backurl" :breadcrumbs="breadcrumbs" >
			
			<!-- TITLE -->
			<v-card>
				<v-card-title>
					<span v-if="detailSite != null && mapDetailObj != null">
						{{ this.mapDetailObj.map_name }}
					</span>	
				</v-card-title>

				<v-card-text>
					<v-row no-gutters>
						<v-col cols="12" v-if="detailOrg != null">
							<strong>{{ $t('lbl.organization')}}: {{detailOrg.organization_name}}</strong>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12" v-if="detailSite != null" >
							<strong>{{ $t('lbl.site')}}: {{detailSite.site_name}}</strong>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12" v-if="mapDetailObj != null" >
							<strong>{{ $t('lbl.mapAssetType')}}:</strong> {{decodeMapAssetType(this.mapDetailObj.map_asset_type)}}
						</v-col>
					</v-row>
				</v-card-text>
				
				<v-divider v-if="mapDetailObj != null && mapDetailObj.map_asset_type != null && mapDetailObj.map_asset_type != 'only_values'"></v-divider>
				
				<v-card-text v-if="mapDetailObj != null && mapDetailObj.map_asset_type != null && mapDetailObj.map_asset_type != 'only_values'">	
					<v-row no-gutters>
						<v-col cols="12">
							<v-btn class="button-main ma-1" v-if="mapDetailObj != null && mapDetailObj.map_asset_type != null && mapDetailObj.map_asset_type == 'image'" v-on:click="gotoMapRenderingImage()" ><v-icon left dark>desktop_windows</v-icon>{{$t('btn.loadMapRenderImage')}}</v-btn>
							<v-btn class="button-main ma-1" v-if="mapDetailObj != null && mapDetailObj.map_asset_type != null && mapDetailObj.map_asset_type == 'render3d_pro'" v-on:click="gotoMapRenderShin()"><v-icon left dark>desktop_windows</v-icon>{{$t('btn.loadMapRenderShin')}}</v-btn>
							<v-btn class="button-main ma-1" v-if="mapDetailObj != null && mapDetailObj.map_asset_type != null && mapDetailObj.map_asset_type == 'render3d_basic'" v-on:click="gotoMapRenderShin()"><v-icon left dark>desktop_windows</v-icon>{{$t('btn.loadMapRenderShin')}}</v-btn>
							<v-btn class="button-main ma-1" v-if="mapDetailObj != null && mapDetailObj.map_asset_type != null && mapDetailObj.map_asset_type == 'threejs'" v-on:click="gotoMapRenderTheejs()"><v-icon left dark>desktop_windows</v-icon>{{$t('btn.loadMapRenderThreeJs')}}</v-btn>
							
							<v-btn class="button-main ma-1" v-if="mapDetailObj != null && !isEmptyString(mapDetailObj.map_link)" v-on:click="openMapLink(mapDetailObj.map_link)" ><v-icon left dark>list_alt</v-icon>{{ $t('btn.mapLink')}}</v-btn>
						</v-col>
					</v-row>
				</v-card-text> 

				<v-divider></v-divider>

				<ct-map-poi-list-polling ref="poiListPolling"></ct-map-poi-list-polling>

			</v-card>

			<!-- DIALOG RENDERING 3D-->
			<ct-map-dlg-render-shin ref="renderShin"></ct-map-dlg-render-shin>

			<!-- DIALOG RENDER THREE JS-->
			<ct-map-dlg-render-threejs ref="renderThreeJs" 
			:orgid="this.$route.params.orgId" 
			:siteid="this.$route.params.siteid" 
			:mapDetailObj="mapDetailObj"
			printMouse="false">
			</ct-map-dlg-render-threejs>

			<!-- DIALOG RENDER IMAGE-->
			<ct-map-dlg-render-image
			ref="renderImage" 
			:orgid="this.$route.params.orgId" 
			:siteid="this.$route.params.siteid" 
			:mapDetailObj="mapDetailObj"
			></ct-map-dlg-render-image>
			
		</ct-main-layout-appgui>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

import ctMapPoiListPolling from "@/components/appgui/ctMapPoiListPolling.vue";

import ctDialogRenderShin from "@/components/commons/ctDialogRenderShin.vue";
import ctDialogRenderThreeJs from "@/components/commons/ctDialogRenderThreeJs.vue";
import ctDialogRenderImage from "@/components/commons/ctDialogRenderImage.vue";

export default {
	i18n,
	data: () => ({
		backurl: '/appgui',
		breadcrumbs:[],
		detailOrg: null,
		detailSite: null, 
		mapDetailObj : null,
	}),
	created(){
		this.detailOrg = this.getEmptyOrgGuiAdmin();
	},
	mounted() {
		//=== BLOCCO LA PAGINA
		this.$root.globalPageLoading = true;

		//=== NAVIGATION BAR
		this.backurl = '/appgui/organization/' + this.$root.$route.params.orgId;
		this.breadcrumbs = [
			{ text: i18n.t('breadcrumb.appgui'), disabled: false, href: '/tools/appgui' }
		];

		//=== STARTUP
		this.loadOrgDetails();
	},	
	destroyed() {
		
	},
	components: {
		'ct-map-poi-list-polling': ctMapPoiListPolling,
		'ct-map-dlg-render-shin': ctDialogRenderShin,
		'ct-map-dlg-render-threejs': ctDialogRenderThreeJs,
		'ct-map-dlg-render-image': ctDialogRenderImage
	},
	methods: {
		loadOrgDetails() 
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			}
			else 
			{
				var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.$route.params.orgId
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadOrgDetails, 'err.loadingOrg');
			}
		},
		callbackLoadOrgDetails(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.detailOrg = responseData;

				this.breadcrumbs.push({text: this.detailOrg.organization_name, disabled: false, href: '/tools/appgui/organization/'+ this.$route.params.orgId });

				this.loadSiteDetails();
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingOrg"));
			}
		},
		loadSiteDetails() 
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			}
			else if(this.isEmptyString(this.$route.params.siteid))
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			} 
			else 
			{
				var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.$route.params.orgId  + '/sites/' + this.$route.params.siteid;
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadSiteDetails);
			} 			
		}, 
		callbackLoadSiteDetails(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.detailSite = responseData;

				this.breadcrumbs.push({text: this.detailSite.site_name, disabled: false});

				this.loadMapDetails();
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingSite"));
			}
		},	
		loadMapDetails() 
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			}
			else if(this.isEmptyString(this.$route.params.siteid))
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.$route.params.mapid))
			{
				this.$root.setDialogMsg(i18n.t("err.mapSelectedNotValid"));
			} 
			else 
			{
				var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.$route.params.orgId  + '/sites/' + this.$route.params.siteid +'/maps/' + this.$route.params.mapid;
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadMapDetails);
			}
		},
		callbackLoadMapDetails(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.mapDetailObj = responseData;

				this.breadcrumbs.push({text: this.mapDetailObj.map_name, disabled: false});
				
				//=== 
				//HO DOVUTO PROCEDERE COSI PERCHE L'OGGETTO PASSATO TRAMITE PROPS
				// SI AGGIORNAVA DOPO CON UN LEGGERO RITARDO ED IL PRIMO POLLING ANDAVA MALE
				//===
				var orgid2polling = this.$route.params.orgId;
				var siteid2polling = this.$route.params.siteid;
				this.$refs.poiListPolling.injectMapDetailObj(orgid2polling, siteid2polling, this.mapDetailObj);
				this.$refs.poiListPolling.startPoiListPolling();

				//=== SBLOCCO LA PAGINA
				this.$root.globalPageLoading = false;
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingMap"));
			}
		},
		gotoMapRenderShin() 
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.$route.params.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else 
			{
				this.$refs.renderShin.openMapRenderShin(this.$route.params.orgId, this.$route.params.siteid, this.mapDetailObj);
			}
		},
		gotoMapRenderTheejs() 
		{
			this.$refs.renderThreeJs.openMapRenderThreeJs();
		},
		gotoMapRenderingImage() 
		{
			this.$refs.renderImage.openMapRenderImage();
		},
		openMapLink(link)
		{
			window.open(link,'_blank');
		},
	}
}
</script>